const IMPORTANT_VARS = {
  TabelDataPageSize: 25,
};

export default IMPORTANT_VARS;
